<template>
  <modal
        name="columnSelector"
        :draggable="false"
        :scrollable="true"
        height="auto"
         footerClasses="justify-content-center"
         type="notice">
    <card>
      <h5 slot="header" class="header text-center" style="margin-bottom: 5px">컬럼선택</h5>
      <el-row :gutter="0">
        <el-col :span="12">
          <el-table class="table-striped"
                    border
                    style="width: 100%; margin-bottom: 10px;"
                    :data="filterColumn1"
                    ref="table1"
                    :header-cell-style="tableRowStyle">
            <el-table-column
              prop="name"
              label="컬럼명">
            </el-table-column>
            <el-table-column
              label="설정">
              <template slot-scope="props">
                <el-switch v-model="props.row.show">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <el-table class="table-striped"
                    border
                    style="width: 100%; margin-bottom: 10px;"
                    :data="filterColumn2"
                    ref="table2"
                    :header-cell-style="tableRowStyle">
            <el-table-column
              prop="name"
              label="컬럼명">
            </el-table-column>
            <el-table-column
              label="설정">
              <template slot-scope="props">
                <el-switch v-model="props.row.show">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>


      <form @submit.prevent="">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-check" v-on:click="setColumns">설정</el-button>
          <el-button icon="el-icon-close" v-on:click="close">취소</el-button>
        </div>
      </form>
    </card>
  </modal>
</template>

<script>
    import Vue from 'vue'
    import ColumnSettingProxy from "@/proxies/ColumnSettingProxy";
    import {Table, TableColumn, Switch, Row, Col, Button} from 'element-ui'
    import { Card } from 'src/components/UIComponents';
    // import Vmodal from '@/components/UIComponents/VModal'

    // Vue.use(Vmodal)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Switch)

    export default {
        name: "ColumnSelectorModal",
        components: {
            Card,
        },
        created: function () {
        },
        props: {
            pageType: String,
        },
        data() {
            return {
                modals: {
                    columns: [],
                    roleCode: ''
                },
            }
        },
        watch: {

        },
        computed: {
            filterColumn1() {
                const div = parseInt( this.modals.columns.length / 2)
                return this.modals.columns.filter(function(c) {
                    return c.sort <= div
                })
            },
            filterColumn2() {
              const div = parseInt( this.modals.columns.length / 2)
                return this.modals.columns.filter(function(c) {
                    return c.sort > div
                })
            }
        },
        updated: function () {
            this.$refs.table1.doLayout();
            this.$refs.table2.doLayout();
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            close() {
                this.$modal.hide('columnSelector');
                this.$emit('closeModal', false);
            },
            setColumns() {
                new ColumnSettingProxy()
                    .createColumnSetting(this.pageType, {columnSettings : this.modals.columns, roleCode : this.modals.roleCode})
                    .then((response) => {
                        this.$modal.hide('columnSelector');
                        this.$emit('setColumn');
                    })
            },
            // 컬럼설정 조회
            findAllByUserIdAndPageType() {
                new ColumnSettingProxy()
                    .findAllByUserIdAndPageType(this.pageType)
                    .then((response) => {
                          this.modals.columns = response.columnSettings;
                    })
            },
            findAllByUserIdAndPageTypeParam(roleCode, pageType) {
                this.modals.roleCode = roleCode;
                new ColumnSettingProxy({roleCode : roleCode})
                    .findAllByUserIdAndPageType(pageType)
                    .then((response) => {
                        this.modals.columns = response.columnSettings;
                    })
            },
            show() {
                this.$modal.show('columnSelector');
            },

        }
    }
</script>

<style scoped>

</style>
